import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getSiteData, submitContact } from '../store/actions'
import { toast } from 'react-toastify'

export default function Contact() {
    const dispatch = useDispatch()
    const { madarsa } = useSelector((state) => state.reducer || {})
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "", 
        message: ""
    })

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            await dispatch(submitContact(formData))
            toast.success("Message sent successfully")
            setFormData({ name: "", email: "", phone: "", message: "" })
        } catch (error) {
            toast.error("Failed to send message")
        }
    }

    useEffect(() => {
        if (!madarsa) {
            dispatch(getSiteData())
        }
        window.scrollTo(0, 0)
    }, [dispatch, madarsa])

    return (
        <div className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center">
                <span className="text-xs tracking-widest uppercase text-secondary font-semibold mb-6 block">Connect With Us</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8">
                    Universal <span className="font-medium text-secondary">Dialogue</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed">
                    Our administrative sanctuary is active to assist you with inquiries, counseling, and registration formalities.
                </p>
            </section>

            <section className="py-16 px-6 md:px-12 max-w-7xl mx-auto border-t border-gray-100">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center mb-24">
                    <div className="flex flex-col items-center justify-center p-8 bg-primary/5 rounded-[30px] border border-primary/10 hover:-translate-y-2 transition-transform">
                        <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-primary">Location</h4>
                        <p className="text-gray-600 font-light text-sm">{madarsa?.address || 'Plot No: 39, Nashik, India'}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center p-8 bg-secondary/5 rounded-[30px] border border-secondary/10 hover:-translate-y-2 transition-transform">
                        <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-secondary">Phone</h4>
                        <p className="text-gray-600 font-light text-sm">{madarsa?.contact_number || '+91 91722 71113'}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center p-8 bg-primary/5 rounded-[30px] border border-primary/10 hover:-translate-y-2 transition-transform">
                        <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-primary">Email</h4>
                        <p className="text-gray-600 font-light text-sm">{madarsa?.email || 'info@faizulhasnain.org'}</p>
                    </div>
                </div>

                <div className="max-w-3xl mx-auto bg-white p-10 rounded-[40px] shadow-sm border border-gray-100">
                    <h3 className="text-2xl font-light mb-8 text-center text-primary">Send an Inquiry</h3>
                    <form className="space-y-8" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <input
                                type="text"
                                placeholder="Full Name"
                                className="w-full bg-gray-50 border-b-2 border-gray-200 py-4 px-4 text-sm focus:border-secondary outline-none transition-colors rounded-t-xl"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                required
                            />
                            <input
                                type="email"
                                placeholder="Email Address"
                                className="w-full bg-gray-50 border-b-2 border-gray-200 py-4 px-4 text-sm focus:border-secondary outline-none transition-colors rounded-t-xl"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                required
                            />
                        </div>
                        <input
                            type="text"
                            placeholder="Subject / Phone"
                            className="w-full bg-gray-50 border-b-2 border-gray-200 py-4 px-4 text-sm focus:border-secondary outline-none transition-colors rounded-t-xl"
                            value={formData.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        />
                        <textarea
                            rows="4"
                            placeholder="Your Message..."
                            className="w-full bg-gray-50 border-b-2 border-gray-200 py-4 px-4 text-sm focus:border-secondary outline-none transition-colors resize-none rounded-t-xl"
                            value={formData.message}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            required
                        ></textarea>
                        <button type="submit" className="w-full py-4 bg-primary text-white font-bold rounded-xl text-sm tracking-widest uppercase hover:bg-primary-light transition-colors shadow-lg active:scale-95">
                            Submit Inquiry
                        </button>
                    </form>
                </div>
            </section>
        </div>
    )
}
